import React, { Component } from 'react';
import get from 'lodash/get';
import { loadScript } from 'utils/loadScript';
import { connect } from 'react-redux';
import { signUpWithGoogle } from 'actions/userActions';

const SCOPES = [
  // eslint-disable-line
  'https://www.googleapis.com/auth/userinfo.email',
  'https://www.googleapis.com/auth/userinfo.profile'
].join(' ');

export default (WrappedComponent) => {
  class GoogleHandleWrapper extends Component {
    constructor(props) {
      super(props);

      this.state = {
        gapiReady: false
      };
    }

    componentDidMount() {
      if (window.gapi) {
        this.initClient();
      } else {
        loadScript('https://apis.google.com/js/api.js').then(() => {
          setTimeout(() => {
            // eslint-disable-next-line
            gapi.load('client:auth2', this.initClient);
          }, 100);
        });
      }
    }

    initClient = () => {
      // Retrieve the discovery document for version 3 of Google Drive API.
      // In practice, your app can retrieve one or more discovery documents.
      // const discoveryUrl = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest';

      // Initialize the gapi.client object, which app uses to make API requests.
      // Get API key and client ID from API Console.
      // 'scope' field specifies space-delimited list of access scopes.
      // eslint-disable-next-line
      if (get(window.gapi, 'client')) {
        window.gapi.client
          .init({
            apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
            clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            scope: SCOPES
          })
          .then(() => {
            this.setState({ gapiReady: true });
          });
      }
    }

    handleGoogleSignUp = (payload) => {
      // eslint-disable-next-line
      const GoogleAuth = gapi.auth2.getAuthInstance();
      // const { success, fail } = payload || {};
      // const { signUpWithGoogle } = this.props;

      if (!GoogleAuth.isSignedIn.get()) {
        GoogleAuth.signIn().then(() => {
          this.handleSignInAction(payload);
        });
      } else {
        this.handleSignInAction(payload);
      }
    }

    handleSignInAction = (payload) => {
      const { signUpWithGoogle: signUpWithGoogleFn } = this.props;
      const {
        remember, bookingData, success, fail
      } = payload || {};
      // eslint-disable-next-line
      const user = gapi.auth2.getAuthInstance().currentUser.get();
      signUpWithGoogleFn(user.getAuthResponse().id_token, remember, bookingData, success, fail);
    }

    render() {
      const { gapiReady } = this.state;

      return (
        <WrappedComponent
          {...this.props}
          gapiReady={gapiReady}
          signUpWithGoogle={this.handleGoogleSignUp}
        />
      );
    }
  }

  const actions = {
    signUpWithGoogle
  };

  return connect(null, actions)(GoogleHandleWrapper);
};



// WEBPACK FOOTER //
// ./src/hocs/withGoogleHandle.js